/* eslint-disable import/prefer-default-export */
import { SnmpV3User } from 'data/snmp/snmp.types';
import {
  FormTemplate,
  FormTemplateSection
} from 'data/template/template.types';
import cloneDeep from 'lodash.clonedeep';

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view' | 'copy'
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'edit') {
    (clonedTemplate.main as FormTemplateSection).fields.AUTHPASSWD.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.PRIVPASSWD.readOnly = true;
  } else if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(
  template: FormTemplate,
  excludingFields: string[]
) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptSnmpUserTemplate(
  template: FormTemplate,
  fieldName: string,
  value: string
): FormTemplate {
  const clonedTemplate = cloneDeep(template);

  if (!clonedTemplate.main?.fields) {
    return clonedTemplate;
  }

  if (fieldName === 'SECURITYLVL') {
    if (value === 'NOAUTHNOPRIV') {
      setRequiredValidationToField(clonedTemplate, 'AUTHPASSWD', false);
      setRequiredValidationToField(clonedTemplate, 'PRIVPASSWD', false);
    } else if (value === 'AUTHNOPRIV') {
      setRequiredValidationToField(clonedTemplate, 'AUTHPASSWD', true);
      setRequiredValidationToField(clonedTemplate, 'PRIVPASSWD', false);
    } else if (value === 'AUTHPRIV') {
      setRequiredValidationToField(clonedTemplate, 'AUTHPASSWD', true);
      setRequiredValidationToField(clonedTemplate, 'PRIVPASSWD', true);
    }
  }
  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();
  return clonedTemplate;
}

function setRequiredValidationToField(template: FormTemplate, fieldName: string, required: boolean) {
  const formSection = (template.main);
  if (formSection == null) {
    return;
  }

  const field = formSection.fields[fieldName];
  if (field == null) {
    return;
  }

  if (field.validation){
    field.validation.required = required;
  }
}
